export class AdminSubscriptionCompanyContact {
  ownerName: string

  ownerEmail: string

  ownerPhone: string

  instagramUrl: string

  facebookUrl: string

  whatsappUrl: string

  whatsappPhone: string

  tiktokUrl: string

  constructor(data: Partial<AdminSubscriptionCompanyContact> = {}) {
    this.ownerName = data.ownerName ?? ""

    this.ownerEmail = data.ownerEmail ?? ""

    this.ownerPhone = data.ownerPhone ?? ""

    this.instagramUrl = data.instagramUrl ?? ""

    this.facebookUrl = data.facebookUrl ?? ""

    this.whatsappUrl = data.whatsappUrl ?? ""

    this.whatsappPhone = data.whatsappPhone ?? ""

    this.tiktokUrl = data.tiktokUrl ?? ""
  }
}
